import { redirect } from "react-router-dom";
import { HREF_BEFORE_GET_SESSION, successResponse } from "../constants";
export const loader = async () => {
  // Get the original href that was saved before the Cognito auth began
  // and redirect to that path if it's available. Return default OK response
  // if no href is found.

  const hrefBeforeGetSession = sessionStorage.getItem(HREF_BEFORE_GET_SESSION);
  if (hrefBeforeGetSession) {
    sessionStorage.removeItem(HREF_BEFORE_GET_SESSION);
    return redirect(hrefBeforeGetSession);
  }

  return successResponse();
};
